import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import { bulkDeleteMaterialsApi } from "#modules/materials/infra/bulkDeleteMaterials.api";
import { customMaterialsQuery } from "#modules/materials/infra/customMaterials.query";

export const useBulkDeleteMaterials = () => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: bulkDeleteMaterialsApi,
    onError: (err: Error) => {
      showErrorToast({ title: err.message });
      errorHandler(err);
    },
    onSettled: () => {
      void queryClient.invalidateQueries(customMaterialsQuery());
    },
  });

  return { bulkDeleteMaterials: mutate, ...rest };
};
